import {
  FETCH_DASHBOARD_INIT,
  FETCH_DASHBOARD_SUCCESS,
  FETCH_DASHBOARD_FAILURE,
  FETCH_DASHBOARD_DATE_SUCCESS,
  FETCH_DASHBOARD_DATE_FAILURE,
  FETCH_DASHBOARD_DATE_INIT,
  FETCH_TASK_MANAGER_INDICATORS_INIT,
  FETCH_TASK_MANAGER_INDICATORS_SUCCESS,
  FETCH_TASK_MANAGER_INDICATORS_FAILURE,
  DASHBOARD_CHANGE_MENU_COLLAPSE_STATE,
  RESET_DASHBOARD,
  CHANGE_LANGUAGE,
  BEHAVIOR_CONFIG,
  SET_TOUR_VIEWED_SUCCESS
} from './types';
import API from './api';
import { localStoreFN } from '../../store/localStorage';
import Config from '../config/';

export function resetDashboard() {
  return {
    type: RESET_DASHBOARD
  };
}

export function changeMenuCollapseState() {
  return {
    type: DASHBOARD_CHANGE_MENU_COLLAPSE_STATE
  };
}

/* Config setting */

function fetchApiSuccess(data) {
  return {
    type: FETCH_DASHBOARD_SUCCESS,
    payload: data
  };
}

function fetchApiFailure(error) {
  console.log(error);
  return {
    type: FETCH_DASHBOARD_FAILURE,
    error
  };
}

function fetchApiInit() {
  return {
    type: FETCH_DASHBOARD_INIT
  };
}

export function fetchDashboardSettingApi(data) {
  return async dispatch => {
    dispatch(fetchApiInit());
    try {
      const resp = await API.data.getSetting(data);
      return dispatch(fetchApiSuccess(resp));
    } catch (error) {
      return dispatch(fetchApiFailure(error));
    }
  };
}

/* Config Max Date */

function fetchApiDateSuccess(data) {
  return {
    type: FETCH_DASHBOARD_DATE_SUCCESS,
    payload: data
  };
}

function fetchApiDateFailure(error) {
  console.log(error);
  return {
    type: FETCH_DASHBOARD_DATE_FAILURE,
    error
  };
}

function fetchApiDateInit() {
  return {
    type: FETCH_DASHBOARD_DATE_INIT
  };
}

// Handle language change
export function handleLanguageChange(langue) {
  return {
    type: CHANGE_LANGUAGE,
    payload: langue
  };
}

// Behaviour config action
export function handelConfigBehavior(config) {
  return {
    type: BEHAVIOR_CONFIG,
    payload: config
  };
}

export function fetchDashboardDateApi(data) {
  return async dispatch => {
    dispatch(fetchApiDateInit());
    try {
      const resp = await API.data.getDate(data);
      return dispatch(fetchApiDateSuccess(resp));
    } catch (error) {
      return dispatch(fetchApiDateFailure(error));
    }
  };
}

export function trackPageRequest(path) {
  return (dispatch, getState, EventTracker) => {
    let auth = localStoreFN().getItem('auth');
    let user = localStoreFN().getItem("user");
    let client = localStoreFN().getItem("tenantId");
    auth = auth === 'true';
    const trackAnalytics = Config.trackAnalytics === 'true';

    if (
      (EventTracker.user == null || EventTracker.user !== user || EventTracker.client !== client)
      && auth
      && user != null
      && client != null
      && trackAnalytics
    ) {
      EventTracker.setProperties(user, client);
    }

    if(EventTracker.user && trackAnalytics) {
      EventTracker.trackPageFullLoaded();
    }
  };
}

function setTourViewedSuccess(data) {
  return {
    type: SET_TOUR_VIEWED_SUCCESS,
    payload: data
  };
}

export function setTourViewed(tour) {
  return async dispatch => {
    try {
      const resp = await API.data.setTourViewded(tour);
      return dispatch(setTourViewedSuccess(resp));
    } catch (error) {
    }
  };
}

/* Config setting */

function fetchTaskManagerIndicatorsApiSuccess(data) {
  return {
    type: FETCH_TASK_MANAGER_INDICATORS_SUCCESS,
    payload: data
  };
}

function fetchTaskManagerIndicatorsApiFailure(error) {
  console.log(error);
  return {
    type: FETCH_TASK_MANAGER_INDICATORS_FAILURE,
    error
  };
}

function fetchTaskManagerIndicatorsApiInit() {
  return {
    type: FETCH_TASK_MANAGER_INDICATORS_INIT
  };
}

export function fetchTaskManagerIndicatorsApi() {
  return async dispatch => {
    dispatch(fetchTaskManagerIndicatorsApiInit());
    try {
      const resp = await API.data.getTaskManagerIndicators();
      return dispatch(fetchTaskManagerIndicatorsApiSuccess(resp));
    } catch (error) {
      return dispatch(fetchTaskManagerIndicatorsApiFailure(error));
    }
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/dashboard/index.js